import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApsServiceService } from '../aps-service.service';

@Component({
  selector: 'app-onlineshopdetails',
  templateUrl: './onlineshopdetails.component.html',
  styleUrls: ['./onlineshopdetails.component.css']
})
export class OnlineshopdetailsComponent implements OnInit {
  loaderdata:any=false
  dataexist:any=false
  data:any=''
  eventdetails:any;
  pages:any=''
  next:any=''
  previous:any=''
  first:any=""
  last:any=""
  limit:any=4
  eventspage:any='';
  eventid:any
  getuserinfo:any;

  constructor(private route: ActivatedRoute,private searchitem: ApsServiceService,private sanitizer:DomSanitizer,private toastr: ToastrService,
    ) { }

  ngOnInit(): void {

    if(localStorage.getItem("userid")){
      this.getuserinfo=1
    }else{
      this.getuserinfo=0

    }


    this.loaderdata=true
    this.eventid = this.route.snapshot.params.id;
    //console.log(this.eventid)
    //console.log(this.route.snapshot.params.eventname)
    this.eventspage=this.route.snapshot.params.eventname
    this.searchitem.productdetails(this.eventid).subscribe((responce) => {
      if(responce.status){
        //console.log(responce)
        this.data=responce.data
        //console.log(this.data)
        this.eventdetails= this.sanitizer.bypassSecurityTrustHtml(responce.data[0].details)
        this.loaderdata=false
   
  }else{
    this.dataexist=false
    this.loaderdata=false
  }
    })
  }

  getitems(datas){
    //console.log(datas)
    if(!datas.shop_rate){
      //console.log("error")
     this.toastr.error("Select any Places")
    }else{
      this.loaderdata=true;

    var string = datas.shop_rate;
    var liststring = string.split(" ");
    var price=liststring[0]
    //console.log(price);

    var placelist = liststring.splice(1);
    var place  = placelist.join(' ');

    //console.log('split')
//console.log(place);


var payloader=[]
  var dataset={}
  dataset["name"]=datas.shophead
  dataset["sku"]=1
  dataset["price"]=parseFloat(price)
  
  dataset["currency"]="USD"
  dataset["quantity"]=1
  payloader.push(dataset)

localStorage.setItem('storedcart',JSON.stringify(payloader))

var payments={
  "currency": "USD",
  "total": parseFloat(price)
}
//console.log(payloader)
//   [{
//     "name": "Red Sox Hat",
//     "sku": "001",
//     "price": "5.00",
//     "currency": "USD",
//     "quantity": 1
// }]
//console.log(payloader)

//console.log(payments)
  this.searchitem.payment(payments,payloader).subscribe((responce)=>{
  //console.log(responce.data)
  this.loaderdata=false
  localStorage.setItem("shoppaymets","true")
  localStorage.setItem("productplace",place)
  localStorage.setItem('totalCart',price)


  window.location.href=responce.data;

  // this.routerItem.navigate([responce.data])
  

  })

    }
    



// var a = "asdasd|dasd|rttewrtert";
// var b = a.split('|');
// // ["asdasd", "dasd", "rttewrtert"]
// var c = b.splice(1);
// // ["dasd", "rttewrtert"]
// var d = c.join(' ');
// //console.log(d)
// // dasdrttewrtert

  }



}
